export class DialogViewPincodeMappingModel{
    constructor(
        public data: any
    ){}
} 